import { ASSET_RADIO, RELAY } from './object-types'

/**
 * Mirrors app/Enums/AssetTypeEnum.php, which is the source of truth for
 * the values and labels. The icons live here because they are
 * presentation, not part of the API contract.
 */
const ADVANCED_RELAY = 'ADVANCED_RELAY'
const EDGE_RELAY = 'EDGE_RELAY'
const HASTY_RELAY = 'HASTY_RELAY'
const PRO_X_RADIO = 'PRO_X_RADIO'
const PRO_X2_RADIO = 'PRO_X2_RADIO'
const NEXT_GEN_RADIO = 'NEXT_GEN_RADIO'
const UNKNOWN_RADIO = 'UNKNOWN_RADIO'

const objects = {
    [ADVANCED_RELAY]: {
        value: ADVANCED_RELAY,
        label: 'AdvancedRelay',
        icon: '/images/assets/icon-relay-advanced.svg',
        objectType: RELAY,
    },
    [EDGE_RELAY]: {
        value: EDGE_RELAY,
        label: 'EdgeRelay',
        icon: '/images/assets/icon-relay-edge.svg',
        objectType: RELAY,
    },
    [HASTY_RELAY]: {
        value: HASTY_RELAY,
        label: 'HastyRelay',
        icon: '/images/assets/icon-relay-hasty.svg',
        objectType: RELAY,
    },
    [PRO_X_RADIO]: {
        value: PRO_X_RADIO,
        label: 'Pro X Radio',
        icon: '/images/assets/icon-asset-radio-prox.svg',
        objectType: ASSET_RADIO,
    },
    [PRO_X2_RADIO]: {
        value: PRO_X2_RADIO,
        label: 'Pro X2 Radio',
        icon: '/images/assets/icon-asset-radio-prox.svg',
        objectType: ASSET_RADIO,
    },
    [NEXT_GEN_RADIO]: {
        value: NEXT_GEN_RADIO,
        label: 'NextGen Radio',
        icon: '/images/assets/icon-asset-radio-nextgen.svg',
        objectType: ASSET_RADIO,
    },
    // A radio with no type. Listed so those radios stay reachable; drop
    // it from a view's options to hide them instead.
    [UNKNOWN_RADIO]: {
        value: UNKNOWN_RADIO,
        label: 'Unknown Radio',
        objectType: ASSET_RADIO,
    },
}

export default Object.freeze(objects)

export const byValue = (value) => objects[value]

export const assetTypeOptions = Object.freeze(Object.values(objects))

/**
 * The asset types belonging to the given search object types.
 *
 * @param {string[]} objectTypes
 * @returns {object[]}
 */
export const assetTypeOptionsFor = (objectTypes) =>
    Object.freeze(assetTypeOptions.filter(({ objectType }) => objectTypes.includes(objectType)))
